import React from 'react';

const Privacy = () => {
  return (
    <div className="max-w-3xl mx-auto p-8 pt-20 min-h-screen">
      <h1 className="text-3xl font-black uppercase tracking-tight mb-6">Privacy Policy</h1>
      <div className="space-y-4 text-muted-foreground">
        <p><strong>Last updated:</strong> [Today's Date]</p>
        <p>Offer Me He Lelo respects your privacy. This policy outlines how we collect and use your data.</p>
        <p><strong>Data Collection:</strong> We collect information you provide directly to us (name, email) and data automatically collected through your use of the site (cookies, analytics).</p>
        <p><strong>Data Usage:</strong> We use your data to provide, maintain, and improve our services, and to process your transactions securely.</p>
        <p><strong>Data Sharing:</strong> We do not sell your personal data. We only share necessary information with trusted third-party service providers (like payment processors) strictly for the purpose of fulfilling our services to you.</p>
        <p><strong>Security:</strong> We implement industry-standard security measures to protect your personal information.</p>
        <p><strong>Contact:</strong> For privacy-related inquiries, contact us at [offermehelelo@gmail.com].</p>
      </div>
    </div>
  );
};
export default Privacy;